
export default class LoginController {

	constructor (
		User,
		credentials,
		$state,
		$filter
	) {
		// translations
		var translate = $filter('translate');
		this.translate = translate;

		// dependencies
		this.User = User;
		this.$state = $state;

		// inputs
		this.brand = credentials && credentials.brand || '';
		this.email = credentials && credentials.email || '';
		this.password = '';

		// outputs
		this.loading = false;
		this.logo = require('../../mangooid-logo.png');

		// set focus (dirty)
		this.setFocus();
	}

	login () {
		if (!this.loading) {
			this.loading = true;
			this.User.login(
				this.brand,
				this.email,
				this.password
			)
			.then(_ => {
				let redirect = {
					state: 'summaryPage',
					params: { stores: 'all' },
				};
				this.loading = false;
				if (this.$state.params.redirect) {
					try {
						redirect = JSON.parse(this.$state.params.redirect);
					} catch (e) {}
				}
				this.$state.go(redirect.state, redirect.params);
			})
			.catch(_ => {
				this.loading = false;
				this.setFocus();
			})
			;
		}
	}

	setFocus () {
		setTimeout(_ => {
			let element;
			if (!this.brand) {
				element = document.getElementById('login-page__form__brand');
			} else if (!this.email) {
				element = document.getElementById('login-page__form__email');
			} else {
				element = document.getElementById('login-page__form__password');
			}

			if (element) {
				element.blur();
				element.focus();
			}
		}, 100);
	}

	showForgotPasswordForm() {
		swal({
			title: this.translate('CHANGE_PASSWORD'),
			text: '<input'
			     +'    class="form-control"'
			     +'    style="display: block"'
			     +'    id="password-reset-brand-name"'
			     +'    placeholder="'+this.translate('BRAND')+'"'
			     +'/>'
			     +'<input'
			     +'    class="form-control"'
			     +'    style="display: block"'
			     +'    id="password-reset-email"'
			     +'    placeholder="'+this.translate('EMAIL')+'"'
			     +'/>',
			html: true,
			showCancelButton: true,
			closeOnConfirm: false,
		}, confirm => {
			if (confirm) {
				var brandName        = document.getElementById('password-reset-brand-name').value;
				var email = document.getElementById('password-reset-email').value;
				if (!brandName) {
					swal.showInputError(this.translate('BRAND_NAME_MANDATORY'));
					return false;
				}
				if (!email) {
					swal.showInputError(this.translate('EMAIL_MANDATORY'));
					return false;
				}
				return this.User.resetPassword(
						brandName,
						email
					)
					.then(_ => swal.close())
					.catch(_ => swal.close());
			}
			return true;
		});
	}

}

LoginController.$inject = [
	'User',
	'credentials',
	'$state',
	'$filter'
];



// WEBPACK FOOTER //
// ./src/page/login/login.controller.js